import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { serviceUserPermissionAdminApi } from '@/api/admin/service-user-permission';
import type { RootState } from '@/store';
import type { IThunkAPI } from '@/store/types';
import type { ILxStaffSummary, IServiceUserPermissionState } from '../types/types';

const initialState: IServiceUserPermissionState = {
  rosterUsersList: [],
};

export const getRosterUserListByClient = createAsyncThunk<Array<ILxStaffSummary>, number, IThunkAPI>(
  'get/roster/user/byClient/list',
  async (clientId, thunkAPI) => {
    try {
      const response = await serviceUserPermissionAdminApi.getRosterUserListByClient(clientId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const serviceUserPermissionAdminSlice = createSlice({
  name: 'serviceUserPermissionAdmin',
  initialState,
  reducers: {
    clearRosterUserList(state) {
      state.rosterUsersList = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(getRosterUserListByClient.fulfilled, (state, action) => {
      const sortedList = action.payload.sort((a: ILxStaffSummary, b: ILxStaffSummary) => {
        const fa = a.firstName.toLowerCase(),
          fb = b.firstName.toLowerCase();
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
      state.rosterUsersList = sortedList;
    });
  },
});

// actions
export const { clearRosterUserList } = serviceUserPermissionAdminSlice.actions;

// selectors
export const rosterUsersList = (state: RootState): IServiceUserPermissionState['rosterUsersList'] =>
  state.serviceUserPermissionAdmin.rosterUsersList;

export default serviceUserPermissionAdminSlice.reducer;
